import { getEnvConfig } from '@geneo2-web/shared-ui';

export const imageIDC = [
  'lesson-plan-sample',
  'chapterImage',
  'ChapterImage1',
  'fluidFrictionImage',
  'topicImage1',
  'lesson-plan-sample',
  'chapterImage',
  'ChapterImage1',
  'fluidFrictionImage',
  'topicImage1',
  'lesson-plan-sample',
  'chapterImage',
  'ChapterImage1',
  'fluidFrictionImage',
  'topicImage1',
];
export const homeworkItem = [
  {
    subject: 'History',
    chapter: 'World War II',
    hwName: 'History Assignment',
    name: 'Deepali',
    completed: '100',
  },
  {
    subject: 'English',
    chapter: 'Shakespearean Sonnets',
    hwName: 'Literature Homework',
    name: 'Deepali',
    completed: '25',
  },
  {
    subject: 'Physics',
    chapter: 'Electricity',
    hwName: 'Physics Worksheet',
    name: 'Deepali',
    completed: '0',
  },
  {
    subject: 'Biology',
    chapter: 'Cell Structure',
    hwName: 'Biology Assignment',
    name: 'Deepali',
    completed: '65',
  },
  {
    subject: 'Geography',
    chapter: 'Natural Landforms',
    hwName: 'Geography Exercise',
    name: 'Deepali',
    completed: '72',
  },
  {
    subject: 'Mathematics',
    chapter: 'Geometry',
    hwName: 'Math Homework',
    name: 'Deepali',
    completed: '22',
  },
  {
    subject: 'Chemistry',
    chapter: 'Chemical Reactions',
    hwName: 'Chemistry Assignment',
    name: 'Deepali',
    completed: '94',
  },
  {
    subject: 'Computer Science',
    chapter: 'Programming Basics',
    hwName: 'Coding Exercise',
    name: 'Deepali',
    completed: '77',
  },
  {
    subject: 'Art',
    chapter: 'Renaissance Artists',
    hwName: 'Art History Project',
    name: 'Deepali',
    completed: '83',
  },
  {
    subject: 'Economics',
    chapter: 'Supply and Demand',
    hwName: 'Economics Worksheet',
    name: 'Deepali',
    completed: '60',
  },
  {
    subject: 'Music',
    chapter: 'Classical Composers',
    hwName: 'Music Assignment',
    name: 'Deepali',
    completed: '79',
  },
  {
    subject: 'Physical Education',
    chapter: 'Fitness Training',
    hwName: 'PE Exercise',
    name: 'Deepali',
    completed: '90',
  },
  {
    subject: 'Psychology',
    chapter: 'Cognitive Processes',
    hwName: 'Psychology Homework',
    name: 'Deepali',
    completed: '72',
  },
  {
    subject: 'Sociology',
    chapter: 'Cultural Anthropology',
    hwName: 'Sociology Assignment',
    name: 'Deepali',
    completed: '88',
  },
  {
    subject: 'Environmental Science',
    chapter: 'Climate Change',
    hwName: 'Environmental Assignment',
    name: 'Deepali',
    completed: '95',
  },
];

const config = getEnvConfig();
export const ALLOW_EDIT_STUDENT_NAME_FOR_SCHOOL_IDS =
  config.environment === 'dev'
    ? []
    : config.environment === 'stage'
    ? []
    : config.environment === 'prod'
    ? [261, 259, 258, 256, 260, 263]
    : [];
